// @flow

import React from "react";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import { compose } from "redux";
import { SectionComponent, Col, Row, Button } from "@components";
import type { State } from "@store/reducers";
import type { PaginationExtendedType, AuthoredBy } from "@types";
import actionCreators from "@modules/hierarchy/actionCreator";
import type { HierarchyChangelog } from "@modules/hierarchy/reducer/change-log/types";
import * as selectors from "@modules/hierarchy/selectors/change-log";
import ChangelogList from "../../components/change-log-list";
import ChangelogFilter from "../../components/change-log-filter";

type OwnProps = $Exact<{
  title: string,
  clientId: number,
}>;

type PropsFromState = $Exact<{
  changelog: Array<HierarchyChangelog>,
  changelogPagination: PaginationExtendedType,
  changelogUsers: Array<AuthoredBy>,
}>;

type PropsFromDispatch = $Exact<{
  getChangelog: typeof actionCreators.GetHierarchyChangelog,
  exportChangelog: typeof actionCreators.ExportHierarchyChangelog,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

export class ChangeLogTable extends React.Component<Props> {
  componentDidMount() {
    this.props.getChangelog({
      clientId: this.props.clientId,
      page: 1,
    });
  }

  handleFilterSubmit = () => {
    this.props.getChangelog({
      clientId: this.props.clientId,
      page: 1,
    });
  };

  handleExportChangelog = () => {
    this.props.exportChangelog({
      clientId: this.props.clientId,
    });
  };

  handlePaginationChange = (page: number) => {
    this.props.getChangelog({
      clientId: this.props.clientId,
      page,
    });
  };

  render() {
    return (
      <div>
        <SectionComponent title={<h5>{this.props.title}</h5>}>
          <Row className="m-0">
            <Col sm={{ size: 11 }} className="p-0">
              <ChangelogFilter
                isLoading={false}
                onSubmit={this.handleFilterSubmit}
                getChangelog={this.handleFilterSubmit}
                changelogUsers={this.props.changelogUsers}
              />
            </Col>
            <Col sm={{ size: 1 }} className="d-flex justify-content-end align-items-end p-0">
              <Button
                materialIcon="file_download"
                className="mb-3"
                onClick={this.handleExportChangelog}
              >
                {this.props.t("EXPORT")}
              </Button>
            </Col>
          </Row>
          <ChangelogList
            changelog={this.props.changelog}
            pagination={this.props.changelogPagination}
            onNextPage={this.handlePaginationChange}
          />
        </SectionComponent>
      </div>
    );
  }
}

const mapStateToProps = (state: State, ownProps: Object): PropsFromState => {
  return {
    changelog: selectors.getHierarchyChangelog(state),
    changelogPagination: selectors.getHierarchyChangelogPagination(state),
    changelogUsers: selectors.getHierarchyChangelogUsers(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  getChangelog: actionCreators.GetHierarchyChangelog,
  exportChangelog: actionCreators.ExportHierarchyChangelog,
};

export default compose(localize(), connect(mapStateToProps, mapDispatchToProps))(ChangeLogTable);
